// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"de45c7b2","358":"9fd0d79c"}[chunkId] + ".chunk.js";
};